import script from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=js"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=617c5dc1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617c5dc1"]])

export default __exports__